/* src/app/modules_v2/investment/investment-company/components/investment-company-detail/investment-company-detail.component.scss */
:host {
  display: block;
}
.icd-panel {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(0, 1.4fr);
  gap: 16px;
}
.icd-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 16px;
  min-width: 0;
}
.icd-card__header,
.icd-block__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.icd-block__header {
  margin-bottom: 8px;
}
.icd-card__title,
.icd-block__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #1a1d23;
  min-width: 0;
}
.icd-card__title mat-icon,
.icd-block__title mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #6b7280;
  flex-shrink: 0;
}
.icd-block__count {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.icd-progress__bar {
  height: 8px;
  border-radius: 999px;
  background: #eef1f4;
  overflow: hidden;
}
.icd-progress__fill {
  height: 100%;
  border-radius: 999px;
  background: #c5d94a;
  transition: width 0.3s ease;
}
.icd-progress__legend {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
  font-size: 12px;
  color: #6b7280;
}
.icd-progress__legend strong {
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.icd-kpis {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-top: 12px;
}
.icd-kpis--compact {
  margin-top: 8px;
}
.icd-kpi {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  background: #f4f6f8;
  border-radius: 8px;
  min-width: 0;
}
.icd-kpi--accent {
  background: #fbfee8;
  border: 1px solid #e5f3a0;
}
.icd-kpi__label {
  font-size: 11px;
  color: #6b7280;
}
.icd-kpi__value {
  font-size: 14px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.icd-lines {
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  border: 1px solid #eef1f4;
  border-radius: 8px;
  overflow: hidden;
}
.icd-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 12px;
  font-size: 13px;
  color: #2f3540;
}
.icd-line + .icd-line {
  border-top: 1px solid #eef1f4;
}
.icd-line__value {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.icd-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.icd-block {
  padding: 10px 0;
}
.icd-block + .icd-block {
  border-top: 1px solid #eef1f4;
}
.icd-block__side {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.icd-block__summary {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}
.icd-block__summary strong {
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.icd-add.cf-btn.mat-mdc-button-base {
  height: 28px !important;
  padding: 0 10px !important;
  font-size: 12px !important;
}
.icd-add.cf-btn.mat-mdc-button-base .mat-icon {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  margin-right: 2px !important;
}
.icd-moves {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.icd-move {
  display: grid;
  grid-template-columns: 90px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 10px;
  padding: 6px 6px 6px 10px;
  background: #f9fafb;
  border: 1px solid #eef1f4;
  border-radius: 6px;
  font-size: 13px;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.icd-move:hover {
  background: #fff;
  border-color: #e5e7eb;
}
.icd-move__date {
  color: #6b7280;
  white-space: nowrap;
}
.icd-move__info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.icd-move__concept,
.icd-move__meta {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.icd-move__concept {
  color: #2f3540;
}
.icd-move__meta {
  font-size: 11px;
  color: #6b7280;
}
.icd-move__amount {
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.icd-move__actions {
  display: flex;
  align-items: center;
  gap: 2px;
}
.icd-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.icd-icon-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.icd-icon-btn:hover {
  background: #f3f4f6;
  color: #1a1d23;
}
.icd-icon-btn--danger:hover {
  background: #fef2f2;
  color: #dc2626;
}
.icd-more {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 2px;
  margin-top: 2px;
  padding: 2px 6px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  color: #4b5563;
  cursor: pointer;
}
.icd-more mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.icd-more:hover {
  background: #f3f4f6;
  color: #1a1d23;
}
.icd-block__empty {
  font-size: 12px;
  color: #9ca3af;
  padding: 2px 0;
}
.icd-empty {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px 14px;
  background: #f9fafb;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #6b7280;
}
.icd-empty mat-icon {
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.icd-empty--error mat-icon {
  color: #dc2626;
}
@media (max-width: 900px) {
  .icd-panel {
    grid-template-columns: 1fr;
  }
  .icd-kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 480px) {
  .icd-move {
    grid-template-columns: minmax(0, 1fr) auto auto;
  }
  .icd-move__date {
    grid-column: 1/-1;
  }
}
.icd-kpis {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.icd-line__value {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.icd-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  color: #2f3540;
  cursor: pointer;
}
.icd-link mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.icd-link:hover {
  color: #1a1d23;
  text-decoration: underline;
}
.icd-foot {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 14px;
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px dashed #eef1f4;
  font-size: 12px;
  color: #6b7280;
}
.icd-foot strong {
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.icd-foot .icd-more {
  margin-top: 0;
}
/*# sourceMappingURL=investment-company-detail.component.css.map */
